/* eslint-disable quotes */
/* eslint-disable arrow-parens */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
"use strict";
const angular = require("angular");

const uiRouter = require("angular-ui-router");

import routes from "./report.routes";
import uuid from "uuid";

export class ReportComponent {
  /*@ngInject*/
  constructor($http, $scope, $timeout, db, lookup, landuse, theme, $anchorScroll,) {
    this.$http = $http;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.db = db;
    this.lookup = lookup;
    this.landuse = landuse;
    this.theme = theme;
    this.$anchorScroll = $anchorScroll;

    this.$scope.downloadDataLink = "";
    this.$scope.downloadLink = "";

    this.$scope.eContstraints = false;
    this.$scope.rcOption = 1;

    this.$scope.displayErrorMessage = function() {
      $scope.errorMessage = true;
      $timeout(function() {
        $scope.errorMessage = false;
      },5000);
    }

    this.$scope.displaySuccessMessage = function() {
      $scope.successMessage = true;
      $timeout(function() {
        $scope.successMessage = false;
      },5000);
    }

    this.$scope.pageTitle = 'HCD Site Inventory Form';

    //Write columns and column headers to landuse service for later use
    this.landuse.setColumns("report");
    this.landuse.setColHeaders("report");

    this.$scope.siteList = true;
    this.$scope.realisticCapacity = false;
    this.$scope.minDuaCapacity = 0;
    this.$scope.maxDuaCapacity = 0;
    this.$scope.adjustment1 = null;
    this.$scope.adjustment2 = null;
    this.$scope.adjustment3 = null;
    this.$scope.adjustment4 = null;
    this.$scope.adjustment5 = null;
    this.$scope.notes1 = "";
    this.$scope.notes2 = "";
    this.$scope.notes3 = "";
    this.$scope.notes4 = "";
    this.$scope.notes5 = "";
  }

  $onInit() {
    //Load theme functions
    this.theme.initTheme();

    // Add user to DB service if doesn't exist
    if(this.db.getUser().length === 0) {
      this.$http
        .get("/api/users/general")
        .then((response) => {
          this.db.setUser(response.data[0]);
          this.$scope.user = response.data[0];
          this.$scope.role = this.$scope.user.role;
          this.$scope.jurisdiction = this.$scope.user.Organization_Name;
          this.$scope.city = response.data[0].Organization_Name;
          this.$scope.county = this.lookup.getCounty(this.$scope.city);
          this.$http
            .get(`/api/data/hess/parcel/list/${this.$scope.city}`)
            .then((response2) => {
              this.$scope.rowListCollection = response2.data;
            })
            .catch((err) => {
              console.log(err);
            });
          if(this.$scope.role !== "jurisdiction") {
            this.getJurisdictions();
          }
          this.loadReport();
          this.loadAllCodes();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      this.$scope.user = this.db.getUser();
      this.$scope.role = this.$scope.user.role;
      this.$scope.jurisdiction = this.$scope.user.Organization_Name;
      this.$scope.city = this.$scope.user.Organization_Name;
      this.$scope.county = this.lookup.getCounty(this.$scope.city);
      this.$http
        .get(`/api/data/hess/parcel/list/${this.$scope.city}`)
        .then((response) => {
          this.$scope.rowListCollection = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
      if(this.$scope.role !== "jurisdiction") {
        this.getJurisdictions();
      }
      this.loadReport();
      this.loadAllCodes();
    }
  }

  loadReport() {
    this.landuse.setColHeaders("report");
    this.landuse.setColumns("report");

    var colHeaders = this.landuse.getColHeaders();
    var columns = this.landuse.getColumns();
    console.log(columns);
    this.$scope.columns = columns;

    // Load Report Parcels
    this.$http
      .get(`/api/data/hess/parcel/report/list/${this.$scope.jurisdiction}`)
      .then((response) => {
        console.log(response.data);
        this.$scope.prescreenedParcels = response.data;
        this.$scope.rowCollection = response.data;
        this.landuse.setHandsOnData(response.data);

        // Convert true/false values to Yes/No
        this.$scope.rowCollection = _.forEach(
          this.$scope.rowCollection,
          function(item) {
            // console.log(item);
            if(item.hasOwnProperty("in_urban_area") && item.in_urban_area) {
              item.in_urban_area = "YES";
            } else {
              item.in_urban_area = "NO";
            }

            if(item.is_public) {
              item.is_public = "YES";
            } else {
              item.is_public = "NO";
            }

            if(item.is_vacant) {
              item.is_vacant = "Vacant";
            } else if(!item.is_vacant) {
              item.is_vacant = item.existing_use_description;
            }

            if(item.res_units === 0) {
              item.res_units = "";
            }

            if(item.in_slr77) {
              item.in_slr77 = "YES";
            } else {
              item.in_slr77 = "NO";
            }

            if(item.in_slr36) {
              item.in_slr36 = "YES";
            } else {
              item.in_slr36 = "NO";
            }

            if(item.in_liquefact) {
              item.in_liquefact = "YES";
            } else {
              item.in_liquefact = "NO";
            }

            if(item.in_seismic) {
              item.in_seismic = "YES";
            } else {
              item.in_seismic = "NO";
            }

            if(item.in_floodplain) {
              item.in_floodplain = "YES";
            } else {
              item.in_floodplain = "NO";
            }

            if(item.in_landslide) {
              item.in_landslide = "YES";
            } else {
              item.in_landslide = "NO";
            }

            if(item.in_riparian) {
              item.in_riparian = "YES";
            } else {
              item.in_riparian = "NO";
            }

            if(item.in_seismic) {
              item.in_seismic = "YES";
            } else {
              item.in_seismic = "NO";
            }

            if(item.in_habitat) {
              item.in_habitat = "YES";
            } else {
              item.in_habitat = "NO";
            }

            if(item.in_cpad) {
              item.in_cpad = "YES";
            } else {
              item.in_cpad = "NO";
            }

            if(item.action_hab) {
              item.action_hab_desc
                = "Limit new residential development if possible or adopt companion resilient measures to address for identified environmental constraints";
            } else {
              item.action_hab_desc = "";
            }

            if(item.action_pub) {
              item.action_pub_desc
                = "Rezone to allow residential uses or provide documentation from public entity demonstrating plan for housing";
            } else {
              item.action_pub_desc = "";
            }

            if(item.action_vac_nonres) {
              item.action_vac_nonres_desc = "Rezone to allow residential uses";
            } else {
              item.action_vac_nonres_desc = "";
            }

            if(item.action_vac_res_low) {
              item.action_vac_res_low_desc
                = "Use for Low, Very Low, and Moderate Income RHNA";
            } else {
              item.action_vac_res_low_desc = "";
            }

            if(item.action_vac_res_mod) {
              item.action_vac_res_mod_desc
                = "Use for Above Moderate Income RHNA";
            } else {
              item.action_vac_res_mod_desc = "";
            }

            if(item.action_nonvac_nonres) {
              item.action_nonvac_nonres_desc
                = "Rezone to allow residential uses if underutilized";
            } else {
              item.action_nonvac_nonres_desc = "";
            }

            if(item.action_nonvac_res) {
              item.action_nonvac_res_desc
                = "Rezone to allow higher density If there is potential for additional unit capacity";
            } else {
              item.action_nonvac_res_desc = "";
            }

            if(item.action_slr_77) {
              item.action_slr_77_desc
                = "Consider including companion policies from the MTC/ABAG Resilient "
                + "Housing Policy Briefer. Start on page 13 with strategies to accommodate flood risks and explore "
                + "other options to reduce risks for future housing.";
            } else {
              item.action_slr_77_desc = "";
            }

            if(item.action_floodplain) {
              item.action_floodplain_desc
                = "Consider including companion policies from the MTC/ABAG Resilient Housing Policy Briefer. "
                + "Start on page 13 with strategies to accommodate flood risks and explore other options to reduce risks for future housing.";
            } else {
              item.action_floodplain_desc = "";
            }

            if(item.action_liq) {
              item.action_liq_desc
                = "Talk to your local building official to determine if the zoned intensity planned in "
                + "an area with liquefaction would be mitigated during design and construction. Structures "
                + "of a certain size will require substantial foundations, but smaller structures like single "
                + "family homes do not. Also, consider companion policies from the MTC/ABAG Resilient Housing "
                + "Policy Briefer to reduce risks for future housing.";
            } else {
              item.action_liq_desc = "";
            }

            if(item.action_lotsize_feas) {
              item.action_lotsize_feas_desc
                = "If identified for Low, Very Low, or Moderate Income RHNA, demonstrate development feasibility "
                + "for a site of this size to accommodate lower income housing";
            } else {
              item.action_lotsize_feas_desc = "";
            }

            if(item.action_repeat_site) {
              item.action_repeat_site_desc
                = "Rezone to allow residential use by right at HCD-specified densities for housing developments "
                + "with at least 20% of the units affordable to lower income households if identified for "
                + "Low, Very Low, or Moderate Income RHNA";
            } else {
              item.action_repeat_site_desc = "";
            }

            if(item.affh_racially_concentrated_aff_flg === 0 || item.affh_racially_concentrated_aff_flg === "0" ) {
              item.affh_racially_concentrated_aff_flg = "NO";
            } else {
              item.affh_racially_concentrated_aff_flg = "YES";
            }

            if(item.affh_racially_concentrated_pov_flg === '0.0') {
              item.affh_racially_concentrated_pov_flg = "NO";
            } else {
              item.affh_racially_concentrated_pov_flg = "YES";
            }
          }
        );

        if(this.$scope.rowCollection.length === 0) {
          this.$scope.rowCollection = [this.$scope.rowCollection];
        }

        // Hands on Table
        this.$scope.tableDiv = document.getElementById("handsonTable");
        this.$scope.searchField = document.getElementById("search_field");

        var http = this.$http;
        var thisIsValid = this.$scope.thisIsValid;

        this.$scope.handsonTable = new Handsontable(this.$scope.tableDiv, {
          licenseKey: "non-commercial-and-evaluation",
          data: this.$scope.rowCollection,
          allowInsertRow: false,
          manualColumnResize: true,
          colHeaders: colHeaders,
          search: true,
          columns: columns,
          stretchH: "all",
          width: "100%",
          autoWrapRow: true,
          rowHeaders: true,
          filters: true,
          contextMenu: true,
          dropdownMenu: [
            "filter_by_condition",
            "filter_by_value",
            "filter_action_bar",
          ],
          multiColumnSorting: {
            indicator: true,
          },
          exportFile: true,
          language: "en-US",
          // enable column hiding
          hiddenColumns: {
            // set columns that are hidden by default
            columns: [0],
            // show where are hidden columns
            indicators: true,
          },
          afterValidate(isValid, value, row, prop, source) {
            console.log(isValid);
            console.log(value);
            console.log(row);
            console.log(prop);
            console.log(source);
            thisIsValid = isValid;
          },
          afterFilter(filters) {
            console.log(filters);
            console.log($scope.handsonTable.countRows());
          },
          afterRemoveRow(index, amount, physicalRows, source) {
            console.log(index);
            console.log(amount);
            console.log(physicalRows);
            console.log(source);
          },
        });

        this.$scope.handsonTable.render();

        // Add Export Plugin
        this.$scope.exportPlugin
          = this.$scope.handsonTable.getPlugin("exportFile");

        var $scope = this.$scope;

        var handsonTable = this.$scope.handsonTable;

        handsonTable.addHook("afterChange", function(changes, source) {
          var updateData = [];
          console.log(source);
          console.log(thisIsValid);
          changes.forEach(([row]) => {
            var handsonUpdate = handsonTable.getDataAtRow(row);
            console.log(handsonUpdate);
            updateData.push({
              parcel_id: handsonUpdate[0],
              consolidated_sites: handsonUpdate[5],
              site_status: handsonUpdate[17],
              lwr_inc_cap: handsonUpdate[18],
              mod_inc_cap: handsonUpdate[19],
              abvmod_inc_cap: handsonUpdate[20],
              total_capacity: handsonUpdate[21],
              ceqa_elig: handsonUpdate[22],
            });
          });
          console.log(updateData);
          if(typeof thisIsValid === "undefined") {
            console.log("its undefined");
            http
              .post("/api/data/hess/update/report", updateData)
              .then((responseReport) => {
                console.log("283. ", responseReport);
              })
              .catch((err) => {
                console.log(err);
              });
          } else if(!thisIsValid) {
            console.log("its not valid");
          } else {
            // update data in database
            http
              .post("/api/data/hess/update/report", updateData)
              .then((responseReport) => {
                console.log("283. ", responseReport);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  loadReportRC() {
    this.landuse.setColHeaders("reportRC");
    this.landuse.setColumns("reportRC");

    var colHeaders = this.landuse.getColHeaders();
    var columns = this.landuse.getColumns();
    console.log(columns);
    this.$scope.columns = columns;
    this.rowCollectionRC = [];
    // Load Report Parcels
    this.$http
      .get(
        `/api/data/hess/capacity/parcel/report/list/${this.$scope.jurisdiction}`
      )
      .then((response) => {
        console.log(response.data);
        this.$scope.prescreenedParcels = response.data;
        this.$scope.rowCollectionRC = response.data;
        this.landuse.setHandsOnData(response.data);

        // Hands on Table
        if(this.$scope.tableDivRC) {
          delete this.$scope.tableDivRC;
        }
        if(this.$scope.handsonTableRC) {
          delete this.$scope.handsonTableRC;
        }
        this.$scope.tableDivRC = document.getElementById(
          "handsonTableRealisticCapacity"
        );

        var http = this.$http;
        var thisIsValid = this.$scope.thisIsValid;

        this.$scope.handsonTableRC = new Handsontable(this.$scope.tableDivRC, {
          licenseKey: "non-commercial-and-evaluation",
          data: this.$scope.rowCollectionRC,
          allowInsertRow: false,
          manualColumnResize: true,
          colHeaders: colHeaders,
          search: true,
          columns: columns,
          stretchH: "all",
          width: "100%",
          autoWrapRow: true,
          rowHeaders: true,
          filters: true,
          contextMenu: true,
          dropdownMenu: [
            "filter_by_condition",
            "filter_by_value",
            "filter_action_bar",
          ],
          multiColumnSorting: {
            indicator: true,
          },
          exportFile: true,
          language: "en-US",
          // enable column hiding
          hiddenColumns: {
            // set columns that are hidden by default
            columns: [0, 1],
            // show where are hidden columns
            indicators: true,
          },
          afterValidate(isValid, value, row, prop, source) {
            console.log(isValid);
            console.log(value);
            console.log(row);
            console.log(prop);
            console.log(source);
            thisIsValid = isValid;
          },
          afterFilter(filters) {
            console.log(filters);
            console.log($scope.handsonTableRC.countRows());
          },
          afterRemoveRow(index, amount, physicalRows, source) {
            console.log(index);
            console.log(amount);
            console.log(physicalRows);
            console.log(source);
          },
        });

        this.$scope.handsonTableRC.render();

        // Add Export Plugin
        this.$scope.exportPlugin = this.$scope.handsonTableRC.getPlugin("exportFile");

        var $scope = this.$scope;

        var handsonTableRC = this.$scope.handsonTableRC;
        // handsonTableRC.addHook("afterChange", function(changes, source) {
        //   var updateData = [];
        //   console.log(source);
        //   console.log(thisIsValid);
        //   changes.forEach(([row]) => {
        //     var handsonUpdate = handsonTableRC.getDataAtRow(row);
        //     console.log(handsonUpdate);
        //     updateData.push({
        //       parcel_id: handsonUpdate[0],
        //       jurisdiction: handsonUpdate[1],
        //       address: handsonUpdate[2],
        //       zn_code: handsonUpdate[7],
        //       zn_min_dua: handsonUpdate[8],
        //       zn_max_dua: handsonUpdate[9],
        //       acres: handsonUpdate[10],
        //       in_urban_area: handsonUpdate[12],
        //       site_status: handsonUpdate[17],
        //       rhna_affordability: handsonUpdate[18],
        //       mod_inc_cap: handsonUpdate[19],
        //       abvmod_inc_cap: handsonUpdate[20],
        //       total_capacity: handsonUpdate[21],
        //       ceqa_elig: handsonUpdate[22],
        //     });
        //   });
        //   console.log(updateData);
        //   if(typeof thisIsValid === "undefined") {
        //     console.log("its undefined");
        //     http
        //       .post("/api/data/hess/update/report", updateData)
        //       .then((responseReport) => {
        //         console.log("283. ", responseReport);
        //       })
        //       .catch((err) => {
        //         console.log(err);
        //       });
        //   } else if(!thisIsValid) {
        //     console.log("its not valid");
        //   } else {
        //     // update data in database
        //     http
        //       .post("/api/data/hess/update/report", updateData)
        //       .then((responseReport) => {
        //         console.log("283. ", responseReport);
        //       })
        //       .catch((err) => {
        //         console.log(err);
        //       });
        //   }
        // });
        handsonTableRC.addHook('beforeRemoveRow', function (index, amount,physicalRows, source) {
          console.log(index);
          console.log(amount);
          console.log(physicalRows);
          console.log(source);
          var updateArray = {};
          var updateData = [];

          columns.forEach(element => {
            var test = handsonTableRC.getDataAtRowProp(index, element.data);
            console.log(`${element.data}: ${test}`);
            updateArray[element.data] = test;
          });
          updateData.push(updateArray);
          console.log(updateData);
         
          http.post('/api/data/hess/capacity/parcel/list/remove/', updateData)
          .then(response_remove => {
            console.log("283. ", response_remove);
            $scope.updatingData = false;
          })
          .catch(err => {
            console.log(err)
          })
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  generateReport() {
    this.$scope.reportSpinner = true;
    this.$http
      .get("/api/data/hess/parcel/sites/export")
      .then((response) => {
        // console.log(response.data);
        this.$scope.reportSpinner = false;
        this.$scope.downloadLink = response.data.filePath;
        console.log(this.$scope.downloadLink);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  downloadData() {
    this.$scope.dataSpinner = true;
    this.$http
      .get("/api/data/hess/parcel/data/export")
      .then((response) => {
        // console.log(response.data);
        this.$scope.dataSpinner = false;
        this.$scope.downloadDataLink = response.data.filePath;
        console.log(this.$scope.downloadDataLink);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  updateMainSection(type) {
    if(type === "siteList") {
      this.$scope.pageTitle = 'HCD Sites Inventory Form';
      this.$scope.realisticCapacity = false;
      this.$scope.addToReport = false;
      this.$scope.siteList = true;
      if(this.$scope.handsonTable) {
        this.$scope.handsonTable.destroy();
      }
      this.loadReport();
    } else if(type === "realisticCapacity") {
      this.$scope.pageTitle = 'Realistic Capacity Report';
      this.$scope.siteList = false;
      this.$scope.addToReport = false;
      this.$scope.realisticCapacity = true;
      if(this.$scope.handsonTableRC) {
        this.$scope.handsonTableRC.destroy();
      }
      this.loadReportRC();
    }
  }

  showAddToReport(parcel_id) {
    this.$scope.siteList = false;
    this.$scope.realisticCapacity = false;
    this.$scope.addToReport = true;
    this.$scope.parcel_id = parcel_id;
    this.$scope.hessParcel = {};
    this.$scope.bcrParcel = {};
    this.$scope.adjustment1 = null;
    this.$scope.adjustment2 = null;
    this.$scope.adjustment3 = null;
    this.$scope.adjustment4 = null;

    this.$http
      .get(`/api/data/hess/parcelDetails/${this.$scope.parcel_id}`)
      .then((response) => {
        console.log(response.data);
        this.$scope.hessParcel.parcel_id = response.data[0].parcel_id;
        this.$scope.hessParcel.acres = response.data[0].acres;
        this.$scope.hessParcel.zn_code = response.data[0].zn_code;
        this.$scope.hessParcel.juris_default_density = response.data[0].juris_default_density;
        //Set regional description to residential or non-residential
        if(
          response.data[0].zn_regional_description === "Single Family Residential"
          || response.data[0].zn_regional_description === "Multi-Family Residential"
          || response.data[0].zn_regional_description === "Mixed Use Residential"
        ) {
          this.$scope.hessParcel.zn_regional_description = response.data[0].zn_regional_description;
        } else {
          this.$scope.hessParcel.zn_regional_description = "Non-Residential";
        }
        //Set DUA to null if == -1
        if(parseFloat(response.data[0].zn_min_dua) > -1) {
          this.$scope.hessParcel.zn_min_dua = response.data[0].zn_min_dua;
        } else {
          this.$scope.hessParcel.zn_min_dua = null;
        }

        if(parseFloat(response.data[0].zn_max_dua) > -1) {
          this.$scope.hessParcel.zn_max_dua = response.data[0].zn_max_dua;
        } else {
          this.$scope.hessParcel.zn_max_dua = null;
        }

        if(parseFloat(response.data[0].gp_min_dua) > -1) {
          this.$scope.hessParcel.gp_min_dua = response.data[0].gp_min_dua;
        } else {
          this.$scope.hessParcel.gp_min_dua = null;
        }

        if(parseFloat(response.data[0].gp_max_dua) > -1) {
          this.$scope.hessParcel.gp_max_dua = response.data[0].gp_max_dua;
        } else {
          this.$scope.hessParcel.gp_max_dua = null;
        }

         //Get General plan values
         var gpCode = _.filter(this.$scope.gp_codes, {
          gp_code: response.data[0].gp_code,
        });
        console.log(gpCode);
        if(gpCode.length > 0) {
          this.$scope.hessParcel.gp_min_dua = gpCode[0].gp_min_dua;
          this.$scope.hessParcel.gp_max_dua = gpCode[0].gp_max_dua;
        }

        //Set Min Dua to General PLan if Zoning doesn't exist
        if(parseFloat(response.data[0].zn_min_dua) > 0) {
          this.$scope.min_dua = parseFloat(response.data[0].zn_min_dua);
        } else if(gpCode[0] && gpCode[0].gp_min_dua && parseFloat(gpCode[0].gp_min_dua) > 0) {
          this.$scope.min_dua = parseFloat(gpCode[0].gp_min_dua);
        } else {
          this.$scope.min_dua = 0;
        }
        //Set Max Dua to General PLan if Zoning doesn't exist
        if(response.data[0].zn_max_dua && parseFloat(response.data[0].zn_max_dua) > 0) {
          this.$scope.max_dua = parseFloat(response.data[0].zn_max_dua);
        } else if(gpCode[0] && gpCode[0].gp_max_dua && parseFloat(gpCode[0].gp_max_dua) > 0) {
          this.$scope.max_dua = parseFloat(gpCode[0].gp_max_dua);
        } else {
          this.$scope.max_dua = 0;
        }

        console.log(this.$scope.min_dua);
        console.log(this.$scope.max_dua);

        this.$scope.hessParcel.existing_use_description = response.data[0].existing_use_description;

        if(
          response.data[0].in_urban_area && response.data[0].in_urban_area === true
        ) {
          this.$scope.hessParcel.in_urban_area = "YES";
        } else if(
          response.data[0].in_urban_area && response.data[0].in_urban_area === false
        ) {
          this.$scope.hessParcel.in_urban_area = "NO";
        } else {
          this.$scope.hessParcel.in_urban_area = "";
        }
        console.log(this.$scope.bcrParcel);

        this.$scope.hessParcel.address = response.data[0].address;
        this.$scope.hessParcel.jurisdiction = response.data[0].jurisdiction;


        if(this.$scope.hessParcel.acres) {
          this.$scope.hessParcel.acres = parseFloat(this.$scope.hessParcel.acres);
        }

        this.$scope.minDuaCapacity = (this.$scope.min_dua * this.$scope.hessParcel.acres).toFixed(1);
        this.$scope.maxDuaCapacity = (this.$scope.max_dua * this.$scope.hessParcel.acres).toFixed(1);

        //Set urban area adjustment
        if(response.data[0].in_urban_area == true) {
          this.$scope.adjustment3 = 100;
        } else {
          this.$scope.adjustment3 = null;
        }

        //Set environmental constraints adjustment
        if(
          response.data[0].in_cpad
          || response.data[0].in_floodplain
          || response.data[0].in_habitat
          || response.data[0].in_landslide
          || response.data[0].in_liquefact
          || response.data[0].in_riparian
          || response.data[0].in_seismic
          || response.data[0].in_slr36
          || response.data[0].in_slr77
          || response.data[0].fire_haz_class === "Very High"
          || response.data[0].fire_haz_class === "High"
        ) {
          this.$scope.adjustment4 = null;
          this.$scope.eConstraints = false;
        } else {
          this.$scope.adjustment4 = 100;
          this.$scope.eConstraints = true;
        }
        console.log(this.$scope.adjustment4);
        console.log(this.$scope.eConstraints);
       
        //If there is no Zn Min DUA OR GP Min DUA, hide option 1
        if(
          (!this.$scope.hessParcel.zn_min_dua
          || this.$scope.hessParcel.zn_min_dua <= 0) &&
          (!this.$scope.hessParcel.gp_min_dua
            || this.$scope.hessParcel.gp_min_dua <= 0)
        ) {
          $("#option1Nav").removeClass("active");
          $("#option2Nav").addClass("active");
          $("#link1").removeClass("active");
          $("#link2").addClass("active");
        } else if(parseFloat(this.$scope.hessParcel.zn_min_dua) > 0 || parseFloat(this.$scope.hessParcel.gp_min_dua) > 0) {
          $("#option2Nav").removeClass("active");
          $("#option1Nav").addClass("active");

          $("#link2").removeClass("active");
          $("#link1").addClass("active");
        }

        console.log(this.$scope.hessParcel);

        //Get Default Realistic Capacity Values
        //Set adjustment 1 -- Zoning
        this.$http
          .get(`/api/data/parcel/bcr/${this.$scope.jurisdiction}`)
          .then((responseBCR) => {
            console.log(responseBCR.data);
            this.$scope.bcrParcel = responseBCR.data[0];

            switch (this.$scope.hessParcel.zn_regional_description) {
            case 'Single Family Residential':
              if(this.$scope.bcrParcel.res_sf_sumlev_src === 'juris') {
                this.$scope.adjustment1_units = parseInt(responseBCR.data[0].res_sf_juris_ct, 10);
                this.$scope.adjustment1 = parseFloat(responseBCR.data[0].res_sf) * 100;
                this.$scope.adjustment1_hess = parseFloat(responseBCR.data[0].res_sf) * 100;
                this.$scope.bcrParcel.bcrGeo = responseBCR.data[0].jurisdiction;
              } else if(this.$scope.bcrParcel.res_sf_sumlev_src === 'ma') {
                this.$scope.adjustment1_units = parseInt(responseBCR.data[0].res_sf_ma_ct, 10);
                this.$scope.adjustment1 = parseFloat(responseBCR.data[0].res_sf_ma) * 100;
                this.$scope.adjustment1_hess = parseFloat(responseBCR.data[0].res_sf_ma) * 100;
                this.$scope.bcrParcel.bcrGeo = responseBCR.data[0].bcr_market_area;
              } else if(this.$scope.bcrParcel.res_sf_sumlev_src === 'cty') {
                this.$scope.adjustment1_units = parseInt(responseBCR.data[0].res_sf_cty_ct, 10);
                this.$scope.adjustment1 = parseFloat(responseBCR.data[0].res_sf_cty) * 100;
                this.$scope.adjustment1_hess = parseFloat(responseBCR.data[0].res_sf_cty) * 100;
                this.$scope.bcrParcel.bcrGeo = `${responseBCR.data[0].county} County`;
              }
              break;
            case 'Multi-Family Residential':
              if(this.$scope.bcrParcel.res_mf_sumlev_src === 'juris') {
                this.$scope.adjustment1_units = parseInt(responseBCR.data[0].res_mf_juris_ct, 10);
                this.$scope.adjustment1 = parseFloat(responseBCR.data[0].res_mf) * 100;
                this.$scope.adjustment1_hess = parseFloat(responseBCR.data[0].res_mf) * 100;
                this.$scope.bcrParcel.bcrGeo = responseBCR.data[0].jurisdiction;
              } else if(this.$scope.bcrParcel.res_mf_sumlev_src === 'ma') {
                this.$scope.adjustment1_units = parseInt(responseBCR.data[0].res_mf_ma_ct, 10);
                this.$scope.adjustment1 = parseFloat(responseBCR.data[0].res_mf_ma) * 100;
                this.$scope.adjustment1_hess = parseFloat(responseBCR.data[0].res_mf_ma) * 100;
                this.$scope.bcrParcel.bcrGeo = responseBCR.data[0].bcr_market_area;
              } else if(this.$scope.bcrParcel.res_mf_sumlev_src === 'cty') {
                this.$scope.adjustment1_units = parseInt(responseBCR.data[0].res_mf_cty_ct, 10);
                this.$scope.adjustment1 = parseFloat(responseBCR.data[0].res_mf_cty) * 100;
                this.$scope.adjustment1_hess = parseFloat(responseBCR.data[0].res_mf_cty) * 100;
                this.$scope.bcrParcel.bcrGeo = `${responseBCR.data[0].county} County`;
              }
              break;
            case 'Mixed Residential':
              if(this.$scope.bcrParcel.res_mixed_sumlev_src === 'juris') {
                this.$scope.adjustment1_units = parseInt(responseBCR.data[0].res_mixed_juris_ct, 10);
                this.$scope.adjustment1 = parseFloat(responseBCR.data[0].res_mixed) * 100;
                this.$scope.adjustment1_hess = parseFloat(responseBCR.data[0].res_mixed) * 100;
                this.$scope.bcrParcel.bcrGeo = responseBCR.data[0].jurisdiction;
              } else if(this.$scope.bcrParcel.res_mixed_sumlev_src === 'ma') {
                this.$scope.adjustment1_units = parseInt(responseBCR.data[0].res_mixed_ma_ct, 10);
                this.$scope.adjustment1 = parseFloat(responseBCR.data[0].res_mixed_ma) * 100;
                this.$scope.adjustment1_hess = parseFloat(responseBCR.data[0].res_mixed_ma) * 100;
                this.$scope.bcrParcel.bcrGeo = responseBCR.data[0].bcr_market_area;
              } else if(this.$scope.bcrParcel.res_mixed_sumlev_src === 'cty') {
                this.$scope.adjustment1_units = parseInt(responseBCR.data[0].res_mixed_cty_ct, 10);
                this.$scope.adjustment1 = parseFloat(responseBCR.data[0].res_mixed_cty) * 100;
                this.$scope.adjustment1_hess = parseFloat(responseBCR.data[0].res_mixed_cty) * 100;
                this.$scope.bcrParcel.bcrGeo = `${responseBCR.data[0].county} County`;
              }
              break;
            case 'Non-Residential':
              if(this.$scope.bcrParcel.other_sumlev_src === 'juris') {
                this.$scope.adjustment1_units = parseInt(responseBCR.data[0].other_ct, 10);
                this.$scope.adjustment1 = parseFloat(responseBCR.data[0].other) * 100;
                this.$scope.adjustment1_hess = parseFloat(responseBCR.data[0].other) * 100;
                this.$scope.bcrParcel.bcrGeo = responseBCR.data[0].jurisdiction;
              } else if(this.$scope.bcrParcel.other_sumlev_src === 'ma') {
                this.$scope.adjustment1_units = parseInt(responseBCR.data[0].other_ma_ct, 10);
                this.$scope.adjustment1 = parseFloat(responseBCR.data[0].other_ma) * 100;
                this.$scope.adjustment1_hess = parseFloat(responseBCR.data[0].other_ma) * 100;
                this.$scope.bcrParcel.bcrGeo = responseBCR.data[0].bcr_market_area;
              } else if(this.$scope.bcrParcel.other_sumlev_src === 'cty') {
                this.$scope.adjustment1_units = parseInt(responseBCR.data[0].other_cty_ct, 10);
                this.$scope.adjustment1 = parseFloat(responseBCR.data[0].other_cty) * 100;
                this.$scope.adjustment1_hess = parseFloat(responseBCR.data[0].other_cty) * 100;
                this.$scope.bcrParcel.bcrGeo = `${responseBCR.data[0].county} County`;
              }
              break;
            }

            console.log(this.$scope.bcrParcel.bcrGeo);

            //Calculate Default Realistic Capacity
            this.$scope.maxDuaCapacity = parseFloat(this.$scope.max_dua) * parseFloat(this.$scope.hessParcel.acres);
            console.log(this.$scope.maxDuaCapacity);
            if(this.$scope.adjustment1 > 0) {
              this.$scope.maxDuaCapacity *= this.$scope.adjustment1 / 100;
            }
            if(this.$scope.adjustment2 > 0) {
              this.$scope.maxDuaCapacity *= this.$scope.adjustment2 / 100;
            }
            if(this.$scope.adjustment3 > 0) {
              this.$scope.maxDuaCapacity *= this.$scope.adjustment3 / 100;
            }
            if(this.$scope.adjustment4 > 0) {
              this.$scope.maxDuaCapacity *= this.$scope.adjustment4 / 100;
            }
            if(this.$scope.adjustment5 > 0) {
              this.$scope.maxDuaCapacity *= this.$scope.adjustment5 / 100;
            }
            this.$scope.maxDuaCapacity = this.$scope.maxDuaCapacity.toFixed(2);
          })
          .catch((err) => {
            console.log(err);
          });

        //Set Adjustment 2 -- Affordability
        this.$http
          .get(`/api/data//affordability/bcr/${this.$scope.county}`)
          .then((responseBCR) => {
            console.log(
              "🚀 ~ file: report.component.js ~ line 803 ~ ReportComponent ~ .then ~ responseBCR",
              responseBCR
            );
            this.$scope.affordabilityBRC = responseBCR.data[0];
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  setAffordabilityBCR() {
    console.log(this.$scope.hessParcel.rhna_affordability);
    if(this.$scope.hessParcel.rhna_affordability === "Lower") {
      this.$scope.adjustment2 = (
        parseFloat(this.$scope.affordabilityBRC.inc_lower) * 100
      ).toFixed(0);
      this.$scope.adjustment2_hess = (
        parseFloat(this.$scope.affordabilityBRC.inc_lower) * 100
      ).toFixed(0);
      this.$scope.adjustment2_units = this.$scope.affordabilityBRC.n_inc_lower;
    } else if(this.$scope.hessParcel.rhna_affordability === "Moderate") {
      this.$scope.adjustment2 = (
        parseFloat(this.$scope.affordabilityBRC.inc_mod) * 100
      ).toFixed(0);
      this.$scope.adjustment2_hess = (
        parseFloat(this.$scope.affordabilityBRC.inc_mod) * 100
      ).toFixed(0);
      this.$scope.adjustment2_units = this.$scope.affordabilityBRC.n_inc_mod;
    } else if(this.$scope.hessParcel.rhna_affordability === "Above Moderate") {
      this.$scope.adjustment2 = (
        parseFloat(this.$scope.affordabilityBRC.inc_above) * 100
      ).toFixed(0);
      this.$scope.adjustment2_hess = (
        parseFloat(this.$scope.affordabilityBRC.inc_above) * 100
      ).toFixed(0);
      this.$scope.adjustment2_units = this.$scope.affordabilityBRC.n_inc_above;
    }
    this.updateRealisticCapacity();
  }

  updateRealisticCapacity() {
    //Calculate Default Realistic Capacity
    this.$scope.maxDuaCapacity
      = parseFloat(this.$scope.max_dua)
      * parseFloat(this.$scope.hessParcel.acres);

    if(this.$scope.adjustment1 > 0) {
      this.$scope.maxDuaCapacity *= this.$scope.adjustment1 / 100;
    }
    if(this.$scope.adjustment2 > 0) {
      this.$scope.maxDuaCapacity *= this.$scope.adjustment2 / 100;
    }
    if(this.$scope.adjustment3 > 0) {
      this.$scope.maxDuaCapacity *= this.$scope.adjustment3 / 100;
    }
    if(this.$scope.adjustment4 > 0) {
      this.$scope.maxDuaCapacity *= this.$scope.adjustment4 / 100;
    }
    if(this.$scope.adjustment5 > 0) {
      this.$scope.maxDuaCapacity *= this.$scope.adjustment5 / 100;
    }
    this.$scope.maxDuaCapacity = this.$scope.maxDuaCapacity.toFixed(2);
  }

  updateInfrastructure() {
    console.log(this.$scope.hessParcel.in_urban_area);
    if(this.$scope.hessParcel.in_urban_area === "YES") {
      this.$scope.adjustment3 = 100;
    } else {
      this.$scope.adjustment3 = null;
    }
  }

  loadAllCodes() {
    //Get list of zoning codes. If list doesn't exist in lookup service, request from server
    // if (this.lookup.getZoningCodes().length > 0) {
    //   this.$scope.zn_codes = this.lookup.getZoningCodes();
    // } else {
    this.$http
      .get(`/api/data/parcels/zncodes/${this.$scope.jurisdiction}`)
      .then((response) => {
        this.$scope.zn_codes = response.data;
        //Set zoning codes in lookup service
        this.lookup.setZoningCodes(response.data);
        // console.log('zn_codes', this.$scope.zn_codes);
      })
      .catch((err) => {
        console.log(err);
      });
    // }

    //Get list of GP codes. If list doesn't exist in lookup service, request from server
    // if (this.lookup.getGPCodes().length > 0) {
    //   this.$scope.gp_codes = this.lookup.getGPCodes();

    // } else {
    this.$http
      .get(`/api/data/parcels/gpcodes/${this.$scope.jurisdiction}`)
      .then((response) => {
        this.$scope.gp_codes = response.data;
        //Set GP codes in lookup service
        this.lookup.setGPCodes(response.data);
        // console.log("gp_codes", this.$scope.gp_codes);
      })
      .catch((err) => {
        console.log(err);
      });
    // }

    //Get list of use codes. If list doesn't exist in lookup service, request from server
    if(this.lookup.getUseCodes().length > 0) {
      this.$scope.use_codes = this.lookup.getUseCodes();
    } else {
      this.$http
        .get(`/api/data/hess/parcel/uses/${this.$scope.jurisdiction}`)
        .then((response) => {
          this.$scope.use_codes = response.data;
          this.lookup.setUseCodes(response.data);
          // console.log('use_codes', this.$scope.use_codes);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  // File Export
  exportToFile() {
    this.$scope.exportPlugin.downloadFile("csv", {
      bom: false,
      columnDelimiter: ",",
      columnHeaders: true,
      exportHiddenColumns: false,
      exportHiddenRows: false,
      fileExtension: "csv",
      filename: "site-selection_[YYYY]-[MM]-[DD]",
      mimeType: "text/csv",
      rowDelimiter: "\r\n",
      rowHeaders: true,
    });
  }

  getJurisdictions() {
    this.$http
      .get("/api/data/admin/lookup/jurisdictions")
      .then((response) => {
        console.log(this.$scope.user.role);
        console.log(response.data);
        console.log(response.data[0].jurisdiction.split(","));
        if(this.$scope.user.role === "consultant") {
          var jurisdictions = response.data[0].jurisdiction.split(",");
          var jurisdictionsArray = [];
          jurisdictions.forEach((element) => {
            jurisdictionsArray.push({ jurisdiction: element });
          });
          this.$scope.jurisdictions = jurisdictionsArray;
        } else {
          this.$scope.jurisdictions = response.data;
        }
        console.log(this.$scope.jurisdictions);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  updateJurisdiction() {
    this.landuse.setHandsOnData([]);
    // this.$scope.handsonTable.updateSettings({
    //   data: []
    // });
    if(this.$scope.siteList){
      this.$scope.handsonTable.destroy();
      this.loadReport(this.$scope.jurisdiction);
    } else if(this.$scope.realisticCapacity){
      this.$scope.handsonTableRC.destroy();
      this.loadReportRC(this.$scope.jurisdiction);
    }
  
   
    
  }

  updateRCOption(option) {
    this.$scope.rcOption = option;
  }

  // Start add to list function
  addSitesToRCReport(form) {
    console.log(this.$scope.hessParcel);

    console.log(form);
    this.$scope.submitted = true;

    if(parseFloat(this.$scope.adjustment1) !== parseFloat(this.$scope.adjustment1_hess)) {
      console.log("error");
      console.log(this.$scope.adjustment1);
      console.log(this.$scope.adjustment1_hess);
      console.log(this.$scope.notes_1);
      if(!this.$scope.notes_1 || this.$scope.notes_1 === '') {
        form.$invalid = true;
        this.$scope.missingNotes_1 = true;
        this.$anchorScroll();
        this.$scope.displayErrorMessage();
      } else {
        this.$scope.missingNotes_1 = false;
      }
    } else {
      this.$scope.missingNotes_1 = false;
    }

    if(parseFloat(this.$scope.adjustment2) !== parseFloat(this.$scope.adjustment2_hess)) {
      console.log("error");
      console.log(this.$scope.adjustment2);
      console.log(this.$scope.adjustment2_hess);
      console.log(this.$scope.notes_2);
      if(!this.$scope.notes_2 || this.$scope.notes_2 === '') {
        form.$invalid = true;
        this.$scope.missingNotes_2 = true;
        this.$anchorScroll();
        this.$scope.displayErrorMessage();
      } else {
        this.$scope.missingNotes_2 = false;
      }
    } else {
      this.$scope.missingNotes_2 = false;
    }

    if(form.$invalid) {
      this.$anchorScroll();
      this.$scope.displayErrorMessage();
    } else {
      this.$scope.addToSitesSpinner = true;
      this.$scope.hessParcel.report_id = uuid.v1();
      this.$scope.hessParcel.real_capacity = this.$scope.minDuaCapacity;
      //Set realistic capacity based on Options and Affordability
      if(this.$scope.rcOption === 1) {
        this.$scope.adjustment1 = null;
        this.$scope.adjustment2 = null;
        this.$scope.adjustment3 = null;
        this.$scope.adjustment4 = null;
        this.$scope.adjustment5 = null;

        if(this.$scope.hessParcel.rhna_affordability === "Lower") {
          this.$scope.hessParcel.real_capacity_lower = this.$scope.minDuaCapacity;
        } else if(this.$scope.hessParcel.rhna_affordability === "Moderate") {
          this.$scope.hessParcel.real_capacity_moderate = this.$scope.minDuaCapacity;
        } else if(
          this.$scope.hessParcel.rhna_affordability === "Above Moderate"
        ) {
          this.$scope.hessParcel.real_capacity_above_mod = this.$scope.minDuaCapacity;
        }
      } else if(this.$scope.rcOption === 2) {
        if(this.$scope.hessParcel.rhna_affordability === "Lower") {
          this.$scope.hessParcel.real_capacity_lower = this.$scope.maxDuaCapacity;
        } else if(this.$scope.hessParcel.rhna_affordability === "Moderate") {
          this.$scope.hessParcel.real_capacity_moderate = this.$scope.maxDuaCapacity;
        } else if(
          this.$scope.hessParcel.rhna_affordability === "Above Moderate"
        ) {
          this.$scope.hessParcel.real_capacity_above_mod = this.$scope.maxDuaCapacity;
        }

        this.$scope.hessParcel.market_area = this.$scope.bcrParcel.bcr_market_area;
        this.$scope.hessParcel.adjustment_1 = this.$scope.adjustment1;
        this.$scope.hessParcel.adjustment_2 = this.$scope.adjustment2;
        this.$scope.hessParcel.adjustment_3 = this.$scope.adjustment3;
        this.$scope.hessParcel.adjustment_4 = this.$scope.adjustment4;
        this.$scope.hessParcel.adjustment_5 = this.$scope.adjustment5;
        this.$scope.hessParcel.notes_1 = this.$scope.notes_1;
        this.$scope.hessParcel.notes_2 = this.$scope.notes_2;
        this.$scope.hessParcel.notes_3 = this.$scope.notes_3;
        this.$scope.hessParcel.notes_4 = this.$scope.notes_4;
        this.$scope.hessParcel.notes_5 = this.$scope.notes_5;

        this.$scope.hessParcel.notes_hess_1 = $('#adjustment1_notes').text();
        this.$scope.hessParcel.notes_hess_2 = $('#adjustment2_notes').text();
        this.$scope.hessParcel.notes_hess_3 = $('#adjustment3_notes').text();
        this.$scope.hessParcel.notes_hess_4 = $('#adjustment4_notes').text();
        this.$scope.hessParcel.notes_hess_5 = $('#adjustment5_notes').text();
      }
      console.log(this.$scope.hessParcel);

      this.$http
        .post("/api/data/hess/capacity/parcel/list/add", this.$scope.hessParcel)
        .then(() => {
          this.$scope.rowCollectionRC.push(this.$scope.hessParcel);
          this.$scope.addToSitesSpinner = false;
          this.$scope.hessParcel = {};
          this.$scope.bcrParcel = {};
          this.$scope.adjustment1 = null;
          this.$scope.adjustment2 = null;
          this.$scope.adjustment3 = null;
          this.$scope.adjustment4 = null;
          this.$scope.adjustment5 = null;
          this.$scope.notes1 = "";
          this.$scope.notes2 = "";
          this.$scope.notes3 = "";
          this.$scope.notes4 = "";
          this.$scope.notes5 = "";
          this.updateMainSection("realisticCapacity");
        })
        .catch((err) => {
          console.log(err);
          this.$scope.addToSitesSpinner = false;
        });
    }
  }

  // Start remove from list function
  removeSitesFromRCReport(parcel_id) {
    this.$scope.removeSitesSpinner = false;

    this.$http
      .post(
        "/api/data/hess/capacity/parcel/list/remove",
        this.$scope.removeRecords
      )
      .then(() => {
        var checkIndex;
        // console.log("the remove records: ", this.$scope.removeRecords);

        this.$scope.removeRecords.forEach((element) => {
          checkIndex = this.$scope.listRecords.indexOf(element);
          // console.log(checkIndex);
          this.$scope.listRecords.splice(checkIndex, 1);
          // console.log("the list of records: ", this.$scope.listRecords);

          var array1 = ["in", "parcel_id"];
          var array3 = array1.concat(this.$scope.listRecords);
          // console.log(array3);

          // Set the filter to populate features into the layer.
          this.$scope.map.setFilter("ListLayer", array3);
          this.clearSelected();
        });

        this.$scope.selectedRecords = [];
        this.$scope.removeRecords = [];
        this.$scope.removeSitesSpinner = false;
      })
      .catch((err) => {
        console.log(err);
        this.$scope.removeSitesSpinner = false;
      });
  }
  // End remove from list function
}

export default angular
  .module("hessApp.report", [uiRouter])
  .config(routes)
  .component("report", {
    template: require("./report.html"),
    controller: ReportComponent,
    controllerAs: "reportCtrl",
  }).name;



// WEBPACK FOOTER //
// ./client/app/account/report/report.component.js